import sound1 from "../resources/sounds/sound1.ogg";
import sound2 from "../resources/sounds/sound2.ogg";
import sound3 from "../resources/sounds/sound3.ogg";
import koSound from "../resources/sounds/error.ogg";
import alarmSound from "../resources/sounds/alarm.ogg";
import aplauseSound from "../resources/sounds/aplause.ogg";
import beepSound from "../resources/sounds/beep.ogg";
import promoSound from "../resources/sounds/promo.ogg";
import bellSound from "../resources/sounds/bell.ogg";
import { arrayFunctionFilter } from "./verifier.utils";

const okAudio = new Audio(beepSound);
const koAudio = new Audio(koSound);
const aplauseAudio = new Audio(aplauseSound);
const sound1Audio = new Audio(sound1);
const sound2Audio = new Audio(sound2);
const sound3Audio = new Audio(sound3);
const alarmAudio = new Audio(alarmSound);
const bellAudio = new Audio(bellSound);
const promoAudio = new Audio(promoSound);

export default function playSound(type, buyerTypeId, promotionId) {
  let buyerType;
  let verifier = JSON.parse(sessionStorage.getItem("verifier"));
  let { typeOfVerifier } = verifier;

  if (buyerTypeId && typeOfVerifier !== "exit") {
    buyerType = arrayFunctionFilter("buyertypes", buyerTypeId, "buyerTypeId");
    if (buyerType && buyerType.requiresPdaAlert && buyerType.alertSound) {
      type = buyerType.alertSound;
    }
  }

  let promotion;
  if (promotionId && typeOfVerifier !== "exit") {
    promotion = arrayFunctionFilter("promotions", promotionId, "promotionId");
    if (promotion && promotion.requiresPdaAlert && promotion.alertSound) {
      type = promotion.alertSound;
    }
  }

  switch (type) {
    case "ok":
      okAudio.play();
      break;
    case "ko":
      koAudio.play();
      break;
    case "aplause":
      aplauseAudio.play();
      break;
    case "sound1":
      sound1Audio.play();
      break;
    case "sound2":
      sound2Audio.play();
      break;
    case "sound3":
      sound3Audio.play();
      break;
    case "alarm":
      alarmAudio.play();
      break;
    case "bell":
      bellAudio.play();
      break;
    case "promo":
      promoAudio.play();
      break;
    default:
      break;
  }
}
